import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  base: {
    flexDirection: 'row' as const,
    flexWrap: 'nowrap' as const,
  },
  iconsLeft: {
    flexDirection: 'row',
    alignItems: 'center' as const,
  },
  iconsGap: {
    flex: 1,
    minWidth: 200,
    alignItems: 'center' as const,
    justifyContent: 'flex-start' as const,
    overflow: 'visible' as const,
  },
  iconsRight: {
    minWidth: 48,
    flexDirection: 'row',
    alignItems: 'center' as const,
    marginLeft: 'auto' as const,
  },
  icon: {},
  iconLeft: {
    marginRight: 16,
  },
  iconRight: {
    marginLeft: 16,
  },
});
